

	import { Component, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Pro, ProSearchRequest, PagedResult } from '@shared/models';
	import ProItem from '@client/views/industry/pros/ProItem.vue';

	@Component({
		components: {
			ProItem,
		},
	})
	export default class ArtistPros extends BaseView {


		public modelId: string;
		public list: PagedResult<Pro> = new PagedResult<Pro>();
		public criteria: ProSearchRequest = new ProSearchRequest({ pageIndex: 0, pageSize: 32, sortBy: 'year', sortDirection: 'asc' });

		public async mounted() {
			await this.refresh();
		}

		@Watch('$route', { immediate: true, deep: true })
		public async refresh() {
			this.loading = true;
			try {
				this.criteria = new ProSearchRequest(this.$route.query);
				this.modelId = this.$route.params.id;
				this.criteria.artistIds = [ this.modelId ];
				this.list = await this.$api.proService.search(this.criteria);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this artists associated pros list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public async pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			await this.filter(false);
		}

		/** Applies the specified filter and redirects to the new page with the correct query parameters */
		public async filter(resetPage: boolean) {
			this.scroll.scrollToTop();
			if (resetPage) { this.criteria.pageIndex = 0; }
			this.$router.push({ name: 'artist-pros', params: { id: this.modelId }, query: this.criteria.collapse() }).catch(() => { /* INTENTIONALLY EMPTY */ });
			await this.refresh();
		}



	}

